import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const CustomTableCell = withStyles(() => ({
  head: {
    //backgroundColor: "black",
    color: "black",
    fontSize: 14,
    marginTop: "0px"
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "2px solid rgba(0, 0, 0, .125)",
    marginBottom: 4,
    minHeight: 40,
    "&$expanded": {
      minHeight: 56
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(() => ({
  root: {
    padding: 2
  }
}))(MuiExpansionPanelDetails);

export default function NewCustomerVehicles({
  activeDefects,
  archiveDefects,
  userGroup
}) {
  const [expanded, setExpanded] = useState("Active Work Orders");
  const [allowedUser, setAlloweduser] = [
    "Mechanics",
    "TireMan",
    "Technicians",
    "Dispatchers"
  ].includes(userGroup)
    ? useState(true)
    : useState(false);
  const Tabs_Array = [
    {
      id: "act",
      title: "Active Work Orders",
      bgcolor: "#CCE5FF",
      data: activeDefects,
      heads: [
        {
          id: "date",
          label: "Date"
        },
        { id: "id", label: "Vehicle ID" },
        { id: "type", label: "Type" },
        { id: "desc", label: "Description" },
        {
          id: "source",
          label: "Source"
        },
        { id: "status", label: "Status" }
      ]
    },
    {
      id: "arc",
      title: "Archive Work Orders",
      data: archiveDefects,
      bgcolor: "#D1ECF1",
      heads: [
        {
          id: "date",
          label: "Date"
        },
        { id: "id", label: "Vehicle ID" },
        { id: "type", label: "Type" },
        { id: "desc", label: "Description" },
        {
          id: "source",
          label: "Source"
        },
        { id: "status", label: "Status" },
        { id: "dateComplete", label: "Date Completed" }
        // { id: "assignedTo", label: "Assigned To" }
      ]
    }
  ];
  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  React.useEffect(() => {}, []);
  return (
    <div style={{ marginTop: "25px" }}>
      {Tabs_Array.map(dt => {
        return (
          <ExpansionPanel
            key={dt.title}
            square
            expanded={expanded === dt.title}
            onChange={handleChange(dt.title)}
          >
            <ExpansionPanelSummary
              aria-controls={`${dt.title}d-content`}
              id={`${dt.title}d-header`}
              style={{ backgroundColor: dt.bgcolor }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography>{dt.title}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <DataTable
                rows={dt.data}
                show={expanded}
                heads={dt.heads}
                allowedUser={allowedUser}
              />
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      })}
    </div>
  );
}

class EnhancedTableHead extends React.Component {
  render() {
    return (
      <TableHead>
        <TableRow>
          {this.props.heads.map(
            row => (
              <CustomTableCell key={row.id} padding="checkbox">
                {row.label}
              </CustomTableCell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

let assignedTo = [];
class DataTable extends React.Component {
  state = {
    order: "asc",
    orderBy: "defects",
    data: this.props.rows,
    page: 0,
    rowsPerPage: 10,
    searching: false,
    searchArr: [],
    del: "",
    open: false,
    showMore: false,
    dispMore: "",
    assignTo: ""
  };

  componentDidMount() {}

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };
  handleShowMore = (flag, id) => {
    this.setState({
      showMore: flag
    });
    if (flag === true) {
      this.setState({
        dispMore: id
      });
    } else {
      this.setState({
        dispMore: ""
      });
    }
  };
  handleAssign = (e, crr, id) => {
    const { value } = e.target;
    assignedTo.unshift({ id, value });
  };
  render() {
    let { data, rowsPerPage, page, searching, searchArr } = this.state;

    if (searching) {
      data = searchArr;
    }
    let tempRowsPerPage = rowsPerPage;
    const DescDisplay = ({ desc, id }) => {
      return (
        <div>
          {desc.length > 20 ? (
            <div>
              {!this.state.showMore ? (
                <Typography>
                  {desc.slice(0, 20)}...
                  <Typography
                    style={{
                      fontSize: "10px",
                      color: "rgb(50, 136, 255)",
                      cursor: "pointer"
                    }}
                    onClick={() => this.handleShowMore(true, id)}
                  >
                    Show More
                  </Typography>
                </Typography>
              ) : (
                <div>
                  {this.state.dispMore === id ? (
                    <Typography>
                      {desc}
                      <Typography
                        style={{
                          fontSize: "10px",
                          color: "rgb(50, 136, 255)",
                          cursor: "pointer"
                        }}
                        onClick={() => this.handleShowMore(false, id)}
                      >
                        Show Less
                      </Typography>
                    </Typography>
                  ) : (
                    <Typography>
                      {desc.slice(0, 20)}...
                      <Typography
                        style={{
                          fontSize: "10px",
                          color: "rgb(50, 136, 255)",
                          cursor: "pointer"
                        }}
                        onClick={() => this.handleShowMore(true, id)}
                      >
                        Show More
                      </Typography>
                    </Typography>
                  )}
                </div>
              )}
            </div>
          ) : (
            <Typography>{desc} </Typography>
          )}
        </div>
      );
    };
    const AssignedToDisplay = ({ crr, id, val }) => {
      if (["", null, undefined].includes(crr)) {
        return (
          <FormControl>
            <InputLabel htmlFor="assigned">Select</InputLabel>
            <Select
              native
              value={val}
              onChange={e => this.handleAssign(e, crr, id)}
              inputProps={{
                name: "assigned",
                id: "assigned"
              }}
            >
              <option value="" />
              <option value={"tech"}>Technician</option>
              <option value={"disp"}>Dispatcher</option>
              <option value={"admin"}>Admin</option>
            </Select>
          </FormControl>
        );
      } else {
        return <Typography>{crr}</Typography>;
      }
    };
    return (
      <Paper
        style={{
          width: "100%"
        }}
      >
        <div
          style={{
            overflowX: "auto"
          }}
        >
          <Table style={{}} aria-labelledby="tableTitle" padding="checkbox">
            <EnhancedTableHead heads={this.props.heads} />
            {data.length > 0 ? (
              <TableBody>
                {data
                  .slice(
                    page * tempRowsPerPage,
                    page * tempRowsPerPage + tempRowsPerPage
                  )
                  .map(n => {
                    let val = assignedTo.filter(aa => aa.id === n.id);
                    return (
                      <TableRow hover key={n.customerVehicleId}>
                        <CustomTableCell component="th" scope="row">
                          {n.reportedDateTime}
                        </CustomTableCell>
                        <CustomTableCell component="th" scope="row">
                          <Link
                            to={{
                              pathname: `company/vehicle/${n.id}`,
                              focus: null
                              // client: { client }
                            }}
                          >
                            {n.customerInfo.length > 0
                              ? n.customerInfo[0].customerVehicleId
                              : " "}
                          </Link>
                        </CustomTableCell>
                        <CustomTableCell align="right">
                          {n.defectType}
                        </CustomTableCell>
                        <CustomTableCell align="right">
                          <DescDisplay desc={n.defectDesc} id={n.id} />
                        </CustomTableCell>
                        <CustomTableCell align="right">
                          {n.sourceType}
                        </CustomTableCell>
                        <CustomTableCell align="right">
                          {/* <AssignedToDisplay
                            current={n.assignedToUserId}
                            id={n.id}
                            val={val.value}
                          /> */}
                          {!["REPAIRED", "REVOKED"].includes(n.status) ? (
                            <React.Fragment>
                              {this.props.allowedUser ? (
                                <Link
                                  to={{
                                    pathname: `/defects/work/order/${n.id}`,
                                    state: { description: n.defectDesc }
                                  }}
                                >
                                  {n.status === "NEW" ? "OPEN" : n.status}
                                </Link>
                              ) : (
                                <Typography>
                                  {n.status === "NEW" ? "OPEN" : n.status}
                                </Typography>
                              )}
                            </React.Fragment>
                          ) : (
                            <Typography>{n.status}</Typography>
                          )}
                        </CustomTableCell>
                        {/* {!["REPAIRED", "REVOKED"].includes(n.status) && (
                          <CustomTableCell align="right">
                            <Link
                              to={{
                                pathname: `/defects/work/order/${n.id}`,
                                state: { description: n.defectDesc }
                              }}
                            >
                              WorkOrder
                            </Link>
                          </CustomTableCell>
                        )} */}
                        {["REPAIRED", "REVOKED"].includes(n.status) && (
                          <CustomTableCell align="right">
                            {n.repairedDateTime}
                          </CustomTableCell>
                        )}
                      </TableRow>
                    );
                  })}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <CustomTableCell colSpan={6}>
                    {" "}
                    <div
                      style={{
                        alignContent: "center",
                        justifyContent: "center",
                        marginLeft: "45%",
                        fontSize: 16
                      }}
                    >
                      {" "}
                      No Data{" "}
                    </div>{" "}
                  </CustomTableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={data.length}
          rowsPerPage={tempRowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page"
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page"
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Defects/NewCustomerVehicles.jsx